import type { DispensaryRiskRating } from '@gcv/shared';

/** A backfilled account can still carry 'none', which is truthy - so check for it by name. */
export const isRated = (rating?: DispensaryRiskRating): boolean => !!rating && rating !== 'none';
